import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	chartTitle: {
		id: 'software-deployment-frequency-report.deployment-frequency-bar-chart.no-provider.chart-title',
		defaultMessage: 'Weekly comparison',
		description: 'The bar chart title that shows historical deployment frequency over 12 weeks.',
	},
	titleHelpTooltip: {
		id: 'software-deployment-frequency-report.deployment-frequency-bar-chart.no-provider.title-help-tooltip',
		defaultMessage:
			'A 12-week data feed that helps you compare your deployment frequencies to your batch size. This helps you analyze and evaluate the risk to your deployments.',
		description:
			'The message that is displayed when the mouse is hovered on the question mark beside the bar chart title. It explains how deployment frequency historical data is useful to the user.',
	},
	noProviderTitle: {
		id: 'software-deployment-frequency-report.deployment-frequency-bar-chart.no-provider.no-provider-title',
		defaultMessage: 'Connect your source code management and CI/CD tools',
		description:
			'The title that is shown when no deployment provider is installed in this project and the user is viewing deployment frequency report page',
	},
	noProviderDescription: {
		id: 'software-deployment-frequency-report.deployment-frequency-bar-chart.no-provider.no-provider-description',
		defaultMessage:
			"Based on the data from your tools, you'll see the comparison between batch sizes and production deployments, and much more.",
		description:
			'The description that is shown when no deployment provider is installed in this project and the user is viewing deployment frequency report page',
	},
});
